import React, { ReactNode } from 'react';
import { Stack, Text } from '@croquiscom-pvt/zds';

export interface SectionTitleProps {
  title: ReactNode;
  description: ReactNode;
}
export const SectionTitle = ({ title, description }: SectionTitleProps) => {
  return (
    <Stack direction='column' gap={8}>
      <Text variant={'Head_20_Bold'} color={'textPrimary'}>
        {title}
      </Text>
      <Text variant={'Body_15_Regular'} color={'textSecondary'}>
        {description}
      </Text>
    </Stack>
  );
};
